import { SuspiciousCardTxnTile, TileType } from '@varo/graphql-schema-types';
import GetSuspiciousCardTransactionDetails from 'services/graphql/queries/GetSuspiciousCardTransactionDetails';
import { CombinedError, useQuery, UseQueryExecute } from 'urql';

interface SuspiciousCardTransactionOutput {
  fetching: boolean;
  error?: CombinedError;
  suspiciousCardTxnTile?: SuspiciousCardTxnTile;
  refetchQuery: UseQueryExecute;
}

const useSuspiciousCardTransactionDetails = ({
  transactionId,
}: {
  transactionId: string;
}): SuspiciousCardTransactionOutput => {
  const [{ data, fetching, error }, refetchQuery] = useQuery<{
    suspiciousCardTxnTile: SuspiciousCardTxnTile;
  }>({
    query: GetSuspiciousCardTransactionDetails,
    requestPolicy: 'cache-and-network',
    variables: {
      input: {
        id: transactionId,
        tileType: [
          TileType.SuspiciousCardTxnTile,
          TileType.SuspiciousCardTxnDetailsTile,
          TileType.SuspiciousCardTxnQuestionActionTile,
          TileType.SuspiciousCardTxnQuestionTile,
        ],
      },
    },
  });

  return {
    fetching,
    error,
    suspiciousCardTxnTile: data?.suspiciousCardTxnTile,
    refetchQuery,
  };
};

export default useSuspiciousCardTransactionDetails;
